<script setup>
import { PhxContentSlider } from '@phx-styleguides/iwc';
import { ref } from 'vue';
import CTA from '@maison/components/common/CTA.vue';

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
  label: {
    type: String,
    required: true,
  },
  slides: {
    type: Array,
    required: true,
  },
});

const activeSlideIndex = ref(0);
const onSlideChange = (index) => {
  activeSlideIndex.value = index;
};
</script>

<template>
  <phx-content-slider id="id" :slides="slides" :label="label" @slide-change="onSlideChange">
    <div
      v-for="(slide, index) in slides"
      :key="`content-slider-content-${index}`"
      :class="['content-slider__content', { 'is-active': index === activeSlideIndex }]"
      :aria-hidden="index !== activeSlideIndex"
      :inert="index !== activeSlideIndex"
    >
      <p v-if="slide.title" class="heading-small">
        {{ slide.title }}
      </p>

      <div>
        <div v-if="slide.text" class="rich-text" v-html="slide.text" />

        <c-t-a v-if="slide.cta" v-bind="slide.cta" class="mt-4 sm:mt-2" />
      </div>
    </div>
  </phx-content-slider>
</template>
